import { gsap } from "gsap";
import { splitText, animateSplits } from "./utils/splitText";

export const initHeroAnimations = (existingSplits = null) => {
	const heroSection = document.getElementById("home-hero-section");
	if (!heroSection) return;

	const heroIllustrations = heroSection.querySelectorAll(".home-hero-illustration");

	let heroSplits;
	if (existingSplits) {
		heroSplits = existingSplits;
	} else {
		const heroHeadlines = heroSection.querySelectorAll("h1, p");
		heroSplits = splitText(Array.from(heroHeadlines));
		if (heroIllustrations.length > 0) {
			gsap.set(heroIllustrations, { opacity: 0, scale: 0.9 });
		}
	}

	animateSplits(heroSplits, { staggerDelay: 0.2 });

	if (heroIllustrations.length > 0) {
		gsap.to(heroIllustrations, {
			opacity: 1,
			scale: 1,
			duration: 2,
			delay: 0.2,
			stagger: 0.2,
			ease: "power3.out",
		});
	}
};

const initPreloader = () => {
	const heroSection = document.getElementById("home-hero-section");
	if (!heroSection) return;

	const heroHeadlines = heroSection.querySelectorAll("h1, p");
	const heroIllustrations = heroSection.querySelectorAll(".home-hero-illustration");
	const heroSplits = splitText(Array.from(heroHeadlines));

	if (heroIllustrations.length > 0) {
		gsap.set(heroIllustrations, {
			opacity: 0,
			scale: 0.9,
		});
	}
	// –––––––––––––––––––––––––––––––––––––––––––––––– //
	// ————————————————–– Loader Animation ––—————————– //
	// –––––––––––––––––––––––––––––––––––––––––––––––– //
	const loader = document.getElementById("loader");
	const loaderLogo = document.getElementById("loader-logo");
	const loaderText = document.getElementById("loader-text");
	const compassBg = document.querySelector(".compass-bg");
	const compass = document.querySelector(".compass");
	const maskCircle = document.querySelector("#compassMask circle");

	if (!compassBg || !compass || !maskCircle || !loader) return;

	// Calculate circle circumference for stroke animation
	const radius = 80;
	const circumference = 2 * Math.PI * radius;

	gsap.set(loaderLogo, { scale: 0.7, y: 80, transformOrigin: "center center" });
	gsap.set(loaderText, { opacity: 0, y: 120, transformOrigin: "center center" });
	gsap.set([compass, compassBg, maskCircle], {
		scale: 0,
		transformOrigin: "center center",
	});

	// Create animation timeline
	const tl = gsap.timeline({
		onComplete: () => {
			loader.style.display = "none";
		},
	});

	tl.to(loaderLogo, {
		opacity: 1,
		duration: 1.4,
		ease: "smoothInOut",
	})
		.to(
			[compass, compassBg, maskCircle],
			{
				scale: 1,
				duration: 1.6,
				ease: "smoothInOut",
			},
			"<"
		)
		.to(
			[compassBg, compass],
			{
				rotation: 360,
				duration: 2.2,
				ease: "smoothInOut",
				transformOrigin: "center center",
			},
			"<"
		)
		.fromTo(
			maskCircle,
			{
				strokeDasharray: `0 ${circumference}`,
			},
			{
				strokeDasharray: `${circumference} 0`,
				duration: 3.2,
				ease: "smoothInOut",
			},
			"<"
		)
		.to(
			[loaderLogo, loaderText],
			{
				y: 0,
				opacity: 1,
				duration: 1.2,
				stagger: 0.1,
				ease: "smoothInOut",
			},
			"<=1.6"
		)
		.to(
			loader,
			{
				clipPath: "inset(0 0 100% 0)",
				duration: 1.6,
				ease: "smoothInOut",
			},
			"<=1.6"
		)
		.to(
			loaderLogo,
			{
				yPercent: -50,
				duration: 1.6,
				ease: "smoothInOut",
			},
			"<"
		)
		.add(() => {
			initHeroAnimations(heroSplits);
		}, "<+=0.6");
};

export default initPreloader;
